// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Filters$ReactHooksTemplate = require("../dashboard/filters/filters.res.js");

function emptyState(param) {
  return {
          timestamp: "",
          promoter: 0,
          promoter_percentage: 0.0,
          passive: 0,
          passive_percentage: 0.0,
          detractor: 0,
          detractor_percentage: 0.0,
          total: 0,
          nps_score: 0.0,
          total_triggers: 0,
          response_percentage: 0.0
        };
}

function timestamp(t) {
  return t.timestamp;
}

function promoter(t) {
  return t.promoter;
}

function promoter_percentage(t) {
  return t.promoter_percentage;
}

function passive(t) {
  return t.passive;
}

function passive_percentage(t) {
  return t.passive_percentage;
}

function detractor(t) {
  return t.detractor;
}

function detractor_percentage(t) {
  return t.detractor_percentage;
}

function total(t) {
  return t.total;
}

function nps_score(t) {
  return t.nps_score;
}

function total_triggers(t) {
  return t.total_triggers;
}

function response_percentage(t) {
  return t.response_percentage;
}

function decodeDownloadReport(json) {
  return Json_decode.field("file_name", Json_decode.string, json);
}

function decode(json) {
  return {
          timestamp: Json_decode.field("timestamp", Json_decode.string, json),
          promoter: Json_decode.field("promoter", Json_decode.$$int, json),
          promoter_percentage: Json_decode.field("promoter_percentage", Json_decode.$$float, json),
          passive: Json_decode.field("passive", Json_decode.$$int, json),
          passive_percentage: Json_decode.field("passive_percentage", Json_decode.$$float, json),
          detractor: Json_decode.field("detractor", Json_decode.$$int, json),
          detractor_percentage: Json_decode.field("detractor_percentage", Json_decode.$$float, json),
          total: Json_decode.field("total", Json_decode.$$int, json),
          nps_score: Json_decode.field("nps_score", Json_decode.$$float, json),
          total_triggers: Json_decode.field("total_triggers", Json_decode.$$int, json),
          response_percentage: Json_decode.field("response_percentage", Json_decode.$$float, json)
        };
}

var Report = {
  emptyState: emptyState,
  timestamp: timestamp,
  promoter: promoter,
  promoter_percentage: promoter_percentage,
  passive: passive,
  passive_percentage: passive_percentage,
  detractor: detractor,
  detractor_percentage: detractor_percentage,
  total: total,
  nps_score: nps_score,
  total_triggers: total_triggers,
  response_percentage: response_percentage,
  decodeDownloadReport: decodeDownloadReport,
  decode: decode
};

var emptyReports = emptyState();

var initialState = {
  loading: true,
  reports: emptyReports,
  toggleFilter: false
};

function reducer(state, x) {
  if (typeof x !== "object") {
    if (x === "FetchReportsInProgress") {
      return {
              loading: true,
              reports: state.reports,
              toggleFilter: state.toggleFilter
            };
    } else {
      return {
              loading: state.loading,
              reports: state.reports,
              toggleFilter: !state.toggleFilter
            };
    }
  } else {
    return {
            loading: false,
            reports: x._0,
            toggleFilter: state.toggleFilter
          };
  }
}

function NpsTrend(props) {
  var campaignId = props.campaignId;
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var match$1 = React.useState(function (param) {
        return /* [] */0;
      });
  var setReports = match$1[1];
  var queryParams = Querystringify.parse(props.search);
  var x = Js_dict.get(queryParams, "timestamp");
  var timestamp = x !== undefined ? x : "";
  var url = "/api/v1/nps_trend?campaign_id=" + campaignId + "&timestamp=" + timestamp;
  var toggleFilter = function (param) {
    Curry._1(dispatch, "ToggleFilter");
  };
  var fetchReport = function (param) {
    return Http$ReactHooksTemplate.fetchGetJSONDecode(url, (function (param) {
                  return Json_decode.field("data_points", (function (param) {
                                return Json_decode.list(decode, param);
                              }), param);
                }));
  };
  var onApplyFilter = function (param) {
    Curry._1(dispatch, "ToggleFilter");
    Curry._1(dispatch, "FetchReportsInProgress");
    Js_promise.then_((function (reports) {
            return Promise.resolve(Curry._1(setReports, (function (param) {
                              return reports;
                            })));
          }), fetchReport());
  };
  React.useEffect((function (param) {
          Js_promise.then_((function (reports) {
                  return Promise.resolve(Curry._1(setReports, (function (param) {
                                    return reports;
                                  })));
                }), fetchReport());
        }), []);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                match[0].toggleFilter ? JsxRuntime.jsx(Filters$ReactHooksTemplate.make, {
                        onClose: toggleFilter,
                        onApply: onApplyFilter,
                        showDateFilter: false,
                        showFilterPills: false
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("h2", {
                                      children: "TimeStamp Wise Report",
                                      className: "text-xl font-semibold"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("button", {
                                              children: [
                                                JsxRuntime.jsx("img", {
                                                      className: "h-14-px mr-2-px",
                                                      src: Image$ReactHooksTemplate.filterButton
                                                    }),
                                                "Filters"
                                              ],
                                              className: "bg-ghostwhite border border-gray-400\n            shadow-inner flex rounded py-2 px-3 text-xs",
                                              id: "filters",
                                              onClick: (function (param) {
                                                  Curry._1(dispatch, "ToggleFilter");
                                                })
                                            }),
                                        JsxRuntime.jsxs("button", {
                                              children: [
                                                JsxRuntime.jsx("img", {
                                                      className: "h-14-px mr-1 filter-white",
                                                      src: Image$ReactHooksTemplate.download
                                                    }),
                                                "Download"
                                              ],
                                              className: "bg-pigmentblue border border-gray-400\n              flex rounded py-2 px-3 text-xs text-white",
                                              onClick: (function ($$event) {
                                                  $$event.preventDefault();
                                                  var download_url = "/api/v1/download_nps_trend_report?campaign_id=" + campaignId + "&timestamp=" + timestamp;
                                                  Js_promise.then_((function (file_name) {
                                                          return Promise.resolve((console.log(file_name), RescriptReactRouter.push("/campaigns/report_downloads/" + campaignId)));
                                                        }), Http$ReactHooksTemplate.fetchGetJSONDecode(download_url, decodeDownloadReport));
                                                })
                                            })
                                      ],
                                      className: "flex gap-4"
                                    })
                              ],
                              className: "flex justify-between items-center p-20-px"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsxs("table", {
                                    children: [
                                      JsxRuntime.jsx("thead", {
                                            children: JsxRuntime.jsxs("tr", {
                                                  children: [
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "TimeStamp",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-2"
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "Nps Score",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-2"
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "Total Trigger",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-2"
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "Total Trigger",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-2"
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "Responses %",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-2"
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "Promoter",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-2"
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "Promoter %",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-2"
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "Passive",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-2"
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "Passive %",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-2"
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "Detractor",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-2"
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "Detractor %",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-2"
                                                        })
                                                  ]
                                                }),
                                            className: "font-medium p-4 bg-ghostwhite text-aurometalsaurus"
                                          }),
                                      JsxRuntime.jsx("tbody", {
                                            children: $$Array.of_list(List.map((function (report) {
                                                        return JsxRuntime.jsxs("tr", {
                                                                    children: [
                                                                      JsxRuntime.jsx("td", {
                                                                            children: report.timestamp,
                                                                            className: "px-4 py-2"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: report.nps_score.toString(),
                                                                            className: "px-4 py-2"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: String(report.total_triggers),
                                                                            className: "px-4 py-2"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: String(report.total),
                                                                            className: "px-4 py-2"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: report.response_percentage.toString(),
                                                                            className: "px-4 py-2"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: String(report.promoter),
                                                                            className: "px-4 py-2"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: report.promoter_percentage.toString(),
                                                                            className: "px-4 py-2"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: String(report.passive),
                                                                            className: "px-4 py-2"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: report.passive_percentage.toString(),
                                                                            className: "px-4 py-2"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: String(report.detractor),
                                                                            className: "px-4 py-2"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: report.detractor_percentage.toString(),
                                                                            className: "px-4 py-2"
                                                                          })
                                                                    ],
                                                                    className: "border-b border-bottom-gray-600"
                                                                  });
                                                      }), match$1[0]))
                                          })
                                    ],
                                    className: "text-left table-auto w-full border-separate text-xs font-medium"
                                  }),
                              className: "flex px-20-px"
                            })
                      ]
                    })
              ]
            });
}

var emptyReport = /* [] */0;

var make = NpsTrend;

exports.emptyReport = emptyReport;
exports.Report = Report;
exports.emptyReports = emptyReports;
exports.initialState = initialState;
exports.reducer = reducer;
exports.make = make;
/* emptyReports Not a pure module */
